import { SearchState } from './types';

export const SEARCH_INITIAL_STATE: SearchState = {
  terms: '',
  response: {
    audios: [],
    playlists: [],
  },
  searching: false,
}